// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + ({"333":"staticTextEn","1869":"styles","3190":"menuFr","3198":"menuEs","3589":"staticTextDe","3723":"menuEn","6151":"menuDe","6220":"staticTextFr","7976":"staticTextEs"}[chunkId] || chunkId) + ".js";
};